import {SearchFormProps} from "../../common/searchForm/SearchForm.props";
import {OptionType} from "../../common/searchForm/constants/Option.type";
import {PaymentKeywordTypeList, PaymentTypeList} from "./PaymentType";

export const PaymentSearchFormProps: SearchFormProps = {
    options: [
        {
            type: OptionType.CHECK_LIST,
            key: "type",
            name: "상태",
            list: PaymentTypeList.map(it => it.type),
            stringList: PaymentTypeList.map(it => it.name),
            value: [true, true, true, true, true]
        },
        {
            type: OptionType.TYPE_TEXT,
            key: "keyword",
            name: "검색",
            list: PaymentKeywordTypeList.map(it => it.type),
            stringList: PaymentKeywordTypeList.map(it => it.name),
            value: {
                type: PaymentKeywordTypeList[0].type,
                text: ""
            }
        },
        {
            type: OptionType.DATE,
            key: "date",
            name: "날짜 검색",
            list: [],
            stringList: [],
            value: {
                startDate: "",
                endDate: ""
            }
        }
    ],
    onSearch: () => {},
    onUpdate: () => {}
}